import * as React from 'react'
import { SVGProps } from 'react'
const SvgCaretDown: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 5 5.5 1 1 5" stroke="currentColor" />
  </svg>
)
export default SvgCaretDown
